export default __webpack_public_path__ + "static/media/254.2d42eae0.jpg";